import { render, staticRenderFns } from "./ConfiguracionDispositivo.vue?vue&type=template&id=2605eb42&scoped=true"
import script from "./ConfiguracionDispositivo.vue?vue&type=script&lang=js"
export * from "./ConfiguracionDispositivo.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracionDispositivo.vue?vue&type=style&index=0&id=2605eb42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2605eb42",
  null
  
)

export default component.exports